/**
 * BrandWordmark — horizontal mark + display name for auth pages, nav, etc.
 *
 * Size:
 *   - default: canonical standalone wordmark width
 *   - number: scales to that width while preserving the configured ratio
 */
import { BRAND_DISPLAY_NAME } from '@streamlain/brand';
import type { CSSProperties, FC } from 'react';

import { STREAMLAIN_CORE_LOGO } from './streamlain-logo-mark';
import { StreamLainWordmark } from './StreamLainWordmark';
export interface BrandWordmarkProps {
  /** Width in px. Height scales to preserve the configured wordmark ratio. */
  size?: number;
  className?: string;
  style?: CSSProperties;
  'aria-label'?: string;
}

export const BrandWordmark: FC<BrandWordmarkProps> = ({
  size = STREAMLAIN_CORE_LOGO.wordmark.defaultWidth,
  className,
  style,
  'aria-label': ariaLabel = BRAND_DISPLAY_NAME,
}) => (
  <svg
    className={className}
    width={size}
    height={Math.round(
      size *
        (STREAMLAIN_CORE_LOGO.wordmark.height /
          STREAMLAIN_CORE_LOGO.wordmark.width)
    )}
    viewBox={STREAMLAIN_CORE_LOGO.wordmark.viewBox}
    role="img"
    aria-label={ariaLabel}
    style={style}
  >
    <StreamLainWordmark />
  </svg>
);
